import { call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../helpers'
import CompanyEndpoint from '../persistence/CompanyEndpoint'
import { reduxFetch } from '../http/reduxFetch'

const accountTypes = { ...defineTypes('ACCOUNT')  }

export const initialState = {
  loading: false,
  loaded: false,
  account_info: {}
}

export const actions = {
  getAccountCompany () {
    return { type: accountTypes.REQUEST }
  },
  setBirthdate (birthdate) {
    return { type: 'SET_BIRTHDATE', birthdate: birthdate }
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case accountTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case accountTypes.DESTROY:
      return { ...state, loading: false }
    case accountTypes.FAILURE:
      return { ...state, loading: false }
    case 'SET_BIRTHDATE':
      let new_account_info = { ...account_info, birthdate: action.birthdate }
      return { ...state, account_info: new_account_info }
    case accountTypes.SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        account_info: action.account_info
      }
    default:
      return state
  }
}
export const account_state = (state) => state.account
export const account_info = (state) => state.account.account_info
export const account_id = (state) => state.account.account_info.id

export const selectors = {
  account_info: ({ account }) => {
    return account.account_info
  },
  loaded: ({ account }) => {
    return account.loaded
  },
  company_id: ({ account }) => {
    return account.account_info
      && account.account_info.id
  },
  users: ({ account }) => {
    return account.account_info
      && account.account_info.attributes
      && account.account_info.attributes.users
  },
  birthdate: ({ account }) => {
    return account.account_info
        && account.account_info.birthdate
  }
}

export function * showAccountSaga () {
  try {
    const response = yield call(reduxFetch, CompanyEndpoint.show())
    yield put({ type: accountTypes.SUCCESS, account_info: response.data.attributes })
  } catch (error) {
    yield put({ type: accountTypes.FAILURE, error })
  }
}

export function * rootSaga () {
  yield takeLatest(accountTypes.REQUEST, showAccountSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/account.js